import { ReactNode } from 'react';

import { RecommendationCardEnum, RecommendationCardType } from '@/api/rest/resources/types/recommendations';

export const RECOMMENDATION_CARD_COLORS = {
  [RecommendationCardEnum.monetization]: '#4E57FF',
  [RecommendationCardEnum.risk]: '#7B290F',
  [RecommendationCardEnum.resilience]: '#456E06',
  [RecommendationCardEnum.opportunity]: '#002921',
  [RecommendationCardEnum.insight]: '#002921',
} as const;

export type RecommendationCard = {
  id: string;
  type: RecommendationCardType;
  header?: {
    text?: string;
    children?: ReactNode;
    i18nPath?: string;
    withColor?: boolean;
  };
  body?: {
    collapsed?: {
      text?: string;
      i18nPath?: string;
      children?: ReactNode;
    };
    expanded?: {
      header?: string;
      text?: string;
      i18nPath?: string;
      children?: ReactNode;
      details?: string;
      nextSteps?: string;
      planning?: {
        title?: string;
        text?: string;
        footer?: {
          text?: string;
          value?: string;
        };
      }[];
      isDismisable?: boolean;
    };
  };
  footer?: {
    text?: string;
    value?: string;
  };
  pill?: {
    text?: string;
    i18nPath?: string;
    className?: string;
    showMarker?: boolean;
  };
  styles?: {
    background?: string;
    color?: string;
  };
  affected_assets?: number;
  next?: {
    page?: string;
    filter_params?: {
      plot_group_id?: string;
    };
    sort_orders?: Array<{
      field: string;
      direction: 'asc' | 'desc';
    }>;
  };
};
